module.exports = __webpack_public_path__ + "static/media/14.1df3f48f.gif";